import * as React from 'react';
import { cn } from '@packages/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea ref={ref} className={cn('ww-input', className)} {...props} />
  ),
);
Textarea.displayName = 'Textarea';
